import React from 'react';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { DeliveredDt, IResDashboard } from '@/types/parcel/dashboard';

import { useDate } from '../Context/DateContext';

interface StateData {
  data: DeliveredDt | null;
  isLoading: boolean;
  isError: boolean;
  totalDelivered: number;
}

const useShipmentDelivered = () => {
  const { selectedDate } = useDate();
  const [data, setData] = React.useState<StateData>({
    data: null,
    isLoading: true,
    isError: false,
    totalDelivered: 0,
  });

  const getDeliveredData = async () => {
    const http = initializeHttpProvider();
    try {
      const response = await http.dashboard.deliveredDT(selectedDate);
      setData({
        data: (response as IResDashboard<DeliveredDt>).data,
        isLoading: false,
        isError: false,
        totalDelivered: (response as IResDashboard<DeliveredDt>).data.delivered.reduce(
          (acc, curr) => acc + curr.count,
          0,
        ),
      });
    } catch {
      setData({ data: null, isLoading: false, isError: true, totalDelivered: 0 });
    }
  };

  React.useEffect(() => {
    getDeliveredData();
  }, [selectedDate]);

  return {
    data,
    getDeliveredData,
  };
};

export default useShipmentDelivered;
